import { Injectable } from "@angular/core";
import { Observable, of, BehaviorSubject } from "rxjs";
import { NAVIGATE_ROUTES } from "../../global/constants";
import { ApiService } from "../api-service/api.service";

@Injectable({
  providedIn: "root",
})
export class WhatsNewService {
  apiEndPoint = NAVIGATE_ROUTES;
  private hasUnreadSubject = new BehaviorSubject<boolean>(false);
  public hasUnread$ = this.hasUnreadSubject.asObservable();

  constructor(private apiService: ApiService) {}

  async getWhatsNew(includeFuture: boolean = false): Promise<Observable<any>> {
    const url = `${this.apiEndPoint.WHATS_NEW}?include_future=${includeFuture}&include_inactive=false`;
    const response: any = await this.apiService.get(url).catch((error) => error);
    this.setHasUnread(!!response?.result?.has_unread);
    return of(response);
  }

  async createEntries(payload: any): Promise<Observable<any>> {
    const response = await this.apiService
      .post(this.apiEndPoint.WHATS_NEW, payload)
      .catch((error) => error);
    return of(response);
  }

  async updateEntry(entryId: number, payload: any): Promise<Observable<any>> {
    const response = await this.apiService
      .put(`${this.apiEndPoint.WHATS_NEW}/${entryId}`, payload)
      .catch((error) => error);
    return of(response);
  }

  async markEntryRead(entryId: number | number[]): Promise<Observable<any>> {
    const payload = Array.isArray(entryId)
      ? { entry_ids: entryId }
      : { entry_id: entryId };
    const response = await this.apiService
      .post(this.apiEndPoint.WHATS_NEW_MARK_READ, payload)
      .catch((error) => error);
    return of(response);
  }

  setHasUnread(value: boolean) {
    this.hasUnreadSubject.next(value);
  }
}
